// @flow
import {type AxiosPromise} from 'axios';

import type {ActionType} from 'constants/flow/flowTypes';
import {PRODUCT} from 'constants/actions';

import type {ProductPhotoReviewsType} from './reviewsPhotoListType';

const initialState = {
    status: 'pending',
    list: [],
};

/**
 * Reviews photos list
 * @param {ProductPhotoReviewsType} state Current state
 * @param {ActionType<AxiosPromise>} action Received action
 * @returns {ProductPhotoReviewsType} state New state
 */
export default function reviewsPhotosList(
    state: ProductPhotoReviewsType = initialState,
    action: ActionType<AxiosPromise>,
): ProductPhotoReviewsType {
    switch (action.type) {
        case `${PRODUCT.FETCH_REVIEWS_PHOTOS_LIST}_FULFILLED`: {
            return {
                list: action.payload.data.items,
                status: 'fulfilled',
            };
        }

        case `${PRODUCT.FETCH_REVIEWS_PHOTOS_LIST}_PENDING`: {
            return {
                list: [],
                status: 'pending',
            };
        }
        default: {
            return state;
        }
    }
}

export {initialState};
